import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _ElectronicPayroll, _ElectronicPayrollProperties, _EmployeeContractType, _InfoForTaxReporting } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../../theme/Input/InputDate";
import { ValueTypeSelector } from "../ImportedPayrollConcept/EditorsySelectors/ValueType.Selector";
import { PayrollSheets } from "./PayrollSheets/PayrollSheets";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { ValueTypeConstants } from "./ValueTypeConstants";
import usePaginator from "../../../theme/Component/usePaginator";


export const ElectronicPayroll = () => {

    const electronicpay = useDataBean(_ElectronicPayroll);
    const upelectronic = useDataBean(_ElectronicPayrollProperties);
    const single = Singleton.getInstance();
    const [regexStr, setregexStr] = useState<any>(null)
    const [lista, setLista] = useState<any>([]);
    const paginador = usePaginator();
    const [consttype, setconsttype] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        electronicpay.instance.getElectronicPayrollCatalog(consttype, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        electronicpay.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        electronicpay.instance.deleteElectronicPayroll(electronicpay.bean.IDElectronicPayroll).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        if (!electronicpay.bean.SheetName) {
            toast.warning("Debe proporcionar una Hoja.");
            return;
        }
        if (!electronicpay.bean.ColumnName) {
            toast.warning("Debe proporcionar una Columna.");
            return;
        }
        if (!electronicpay.bean.ColumnIndex) {
            toast.warning("Debe proporcionar un Índice Columna.");
            return;
        }
        if (!electronicpay.bean.DefaultValue) {
            toast.warning("Debe proporcionar un Valor por Defecto.");
            return;
        }
        electronicpay.instance.updateElectronicPayroll(electronicpay.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const updatetElectronicPayrollProperties = () => {
        upelectronic.instance.updatetElectronicPayrollProperties(null).then(
            (resp: any) => {
                getLista();
                console.log(resp)
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDElectronicPayroll', visible: true },
        { title: 'Tipo de Concepto', property: 'ValueTypeName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Nombre Propiedad', property: 'PropertyName', visible: true },
        { title: 'Elemento Descripción', property: 'DescriptionProperty', visible: true },
        { title: 'Elemento Cantidad', property: 'QuantityProperty', visible: true },
        { title: 'Elemento Tarifa', property: 'RateProperty', visible: true },
        { title: 'Elemento Valor', property: 'ValueProperty', visible: true },
        { title: 'Repeticiones Elemento', property: 'NTimesName', visible: true },
        { title: 'Elemento por Defecto', property: 'DefaultConcept', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${electronicpay.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Conceptos de Nómina Electrónica">
            <div className="row">
                <div className="col-md-6">
                    <ValueTypeConstants idSelector={consttype} onChange={(e) => { setconsttype(e) }} />
                </div>
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={updatetElectronicPayrollProperties}>
                        Actualizar Propiedades de Documento Electrónico
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={electronicpay.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Hoja</label>
                                <input type="text" name="SheetName" className="form-control" value={electronicpay.bean.SheetName} onChange={electronicpay.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Columna</label>
                                <input type="text" name="ColumnName" className="form-control" value={electronicpay.bean.ColumnName} onChange={electronicpay.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Índice Columna</label>
                                <input type="text" name="ColumnIndex" className="form-control" value={electronicpay.bean.ColumnIndex} onChange={electronicpay.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor por Defecto</label>
                                <input type="text" name="DefaultValue" className="form-control" value={electronicpay.bean.DefaultValue} onChange={electronicpay.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {electronicpay.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}